import { render, staticRenderFns } from "./ProjectWallet.vue?vue&type=template&id=1df29207&"
import script from "./ProjectWallet.vue?vue&type=script&lang=js&"
export * from "./ProjectWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports